import { create } from "zustand";

/**
 * Estado do modal de ativação de plano particular (hub#489). O interceptor do axios abre o
 * gate em vez de redirecionar para `/onboarding/plan` — isso mata o loop /dashboard↔/plan
 * (hub#389) e deixa o corretor no contexto, escolhendo quando ativar um plano.
 */
interface PlanGateState {
  open: boolean;
  openGate: () => void;
  close: () => void;
}

export const usePlanGateStore = create<PlanGateState>((set) => ({
  open: false,
  openGate: () => set({ open: true }),
  close: () => set({ open: false }),
}));
